import React, { FC, useState } from "react";
import ICImage from "../core-component/ICImage";
import VideoPlayer from "./common/VideoPlayer";
import { MEDIA_TYPE } from "../utils/AppEnumerations";
import { IServiceForSubCategory } from "../screens/product-services/Web/ProductServiceDetailsWebController";
import Modal from "./PublicModal";
import Carousel from "react-material-ui-carousel";
import { Paper } from "@material-ui/core";

interface PublicServiceCarouselProps {
  items: IServiceForSubCategory[];
  animation?: "slide" | "fade";
  timeout?: number;
  indicators?: boolean;
  navButtonsAlwaysInvisible?: boolean;
}

const PublicTrendingServiceCarousel: FC<PublicServiceCarouselProps> = ({
  items,
  animation = "slide",
  timeout = 1500,
  indicators = false,
  navButtonsAlwaysInvisible = true,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [serviceId, setServiceId] = useState<number>();

  const handleServiceClick = (id: number) => {
    setServiceId(id);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const filteredItems = items
    ?.flatMap((item) => {
      const media = item.app_media[0];
      return media
        ? {
            ...media,
            serviceId: item.id,
            itemTitle: item.service_title,
          }
        : [];
    })
    .filter((media) => media.media_type !== MEDIA_TYPE.pdf);

  return (
    <>
      <Carousel
        animation={animation}
        autoPlay={true}
        indicators={indicators}
        navButtonsAlwaysInvisible={navButtonsAlwaysInvisible}
      >
        {filteredItems &&
          filteredItems.length > 0 &&
          filteredItems.map((item, index) => (
            <Paper key={index}>
              <div key={index} className="flex justify-center">
                {item.media_type === MEDIA_TYPE.video ? (
                  <div>
                    <VideoPlayer
                      control={[
                        "play",
                        "progress",
                        "current-time",
                        "mute",
                        "fullscreen",
                        "volume",
                        "play-large",
                      ]}
                      source={item.media_url}
                    />
                  </div>
                ) : (
                  <div>
                    <ICImage
                      imageUrl={item.media_url}
                      className="!object-contain  aspect-[16/9] h-full w-full"
                      alt={`carousel-item-${index}`}
                      scaled={false}
                      onClick={() => handleServiceClick(item.serviceId)}
                    />
                    <div className="absolute w-full mt-2 h-full text-skin-title-insights z-[998] text-2xl">
                      <div className="flex justify-center">
                        {item.itemTitle}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </Paper>
          ))}
      </Carousel>
      {isModalOpen && serviceId && (
        <Modal id={serviceId} closeModal={closeModal} />
      )}
    </>
  );
};

export default PublicTrendingServiceCarousel;
